// extracted by mini-css-extract-plugin
export default {"alert":"BaseLayout_alert__4+3BY","alertTitle":"BaseLayout_alertTitle__yPiB7","link":"BaseLayout_link__mk+Wq","container":"BaseLayout_container__AANt1"};